import React from 'react'
import { graphql, Link } from 'gatsby'
import Helmet from 'react-helmet'
import _ from 'lodash'

import { createLocationTags } from '../../services/job-location'

import Layout from '../../components/layout'
import Block from '../../components/waypoint-block'
import DetailsAccordion from '../../components/details-accordion'

const JobDetailPage = ({ data }) => {
  const { uid, data: job } = _.get(data, [
    'allPrismicJobs',
    'edges',
    '0',
    'node',
  ])
  const jobDetails = job.body.find(({ primary }) => primary)?.primary
  const locationTags = createLocationTags(job)

  return (
    <React.Fragment>
      <Helmet
        title="Versett – Careers"
        meta={[
          {
            name: 'description',
            content:
              'Versett is designed to be a place for doing meaningful work. Our team is tight-knit and dedicated to building great products.',
          },
          { name: 'keywords', content: 'versett, career, job, work' },
          { property: 'og:title', content: 'Versett – Careers' },
          {
            property: 'og:description',
            content:
              'Versett is designed to be a place for doing meaningful work. Our team is tight-knit and dedicated to building great products.',
          },
          {
            property: 'og:image',
            content: 'https://versett.com/images/social-careers.jpg',
          },
          { property: 'og:url', content: 'https://versett.com/careers/' },
          { name: 'twitter:card', content: 'summary_large_image' },
          { property: 'og:site_name', content: 'Versett' },
          { name: 'twitter:image:alt', content: 'Careers' },
        ]}
      >
        <html lang="en" className="s-careers" />
      </Helmet>
      <Layout>
        <div className="optimal-width optimal-width--center">
          <Block>
            <section className="s-container">
              <div className="t-section-heading--even-less-bottom">
                <h2 className="h3" style={{ width: 'auto' }}>
                  {job?.title}
                </h2>
                <p className="s-careers--info-tag">
                  {job?.work_type ?? 'full time'} / {locationTags[0]}
                  {locationTags[1] && <br />}
                  {locationTags[1]} {locationTags[2] && ' / '} {locationTags[2]}
                  {job?.department && <br />}
                  {job?.department}
                </p>
              </div>
              <div className="t-section-heading--even-less-bottom">
                <Link
                  className="button button--outline"
                  to={`/careers/${uid}/apply`}
                >
                  APPLY
                </Link>
              </div>
            </section>
          </Block>

          <Block>
            <section className="s-container s-readme__faq">
              <dl>
                {jobDetails &&
                  Object.keys(jobDetails).map((key, index) => (
                    <DetailsAccordion
                      key={index}
                      heading={
                        data?.allCustomTypeJobs?.edges[0]?.node?.Main?.body
                          ?.config?.choices?.job_details?.non_repeat[key]
                          ?.config?.label ?? _.startCase(key.replace(/_/g, ' '))
                      }
                      open={index === 0}
                    >
                      <div
                        className="color-secondary"
                        dangerouslySetInnerHTML={{
                          __html: jobDetails[key].html,
                        }}
                      />
                    </DetailsAccordion>
                  ))}
              </dl>
            </section>
          </Block>

          <section className="s-container c-services--less-top">
            <Link
              className="button button--outline button--outline--stretch c-services-cta"
              to={`/careers/${uid}/apply`}
            >
              APPLY FOR THIS JOB
            </Link>
          </section>
        </div>
      </Layout>
    </React.Fragment>
  )
}

export default JobDetailPage

export const query = graphql`
  query($uid: String) {
    allPrismicJobs(filter: { uid: { eq: $uid } }) {
      edges {
        node {
          uid
          data {
            title
            country
            city
            work_type
            department
            body {
              ... on PrismicJobsBodyJobDetails {
                id
                primary {
                  job_description {
                    html
                  }
                  the_opportunity {
                    html
                  }
                  what_you_bring_to_the_table {
                    html
                  }
                  interview_process {
                    html
                  }
                  perks_at_versett {
                    html
                  }
                  core_values {
                    html
                  }
                }
              }
            }
          }
        }
      }
    }
    allCustomTypeJobs {
      edges {
        node {
          Main {
            body {
              config {
                choices {
                  job_details {
                    non_repeat {
                      core_values {
                        config {
                          label
                        }
                      }
                      interview_process {
                        config {
                          label
                        }
                      }
                      job_description {
                        config {
                          label
                        }
                      }
                      perks_at_versett {
                        config {
                          label
                        }
                      }
                      the_opportunity {
                        config {
                          label
                        }
                      }
                      what_you_bring_to_the_table {
                        config {
                          label
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
